import baseRequest from "./baseReuqest";

export function getCrnExecutorsWithNames() {
    return baseRequest(`/api/call-center/crn-executors-with-names`);
}

export function getCrnExecutorsWithProperties() {
    return baseRequest(`/api/call-center/crn-executors-with-properties`);
}
